import React from 'react'
import Typography from '@ui/typography'
import cn from '@ui/utils/cn'
import Icon from '@ui/elements/Icon'
import { colors } from '@ui/colors'
import Animated, {
  interpolate,
  interpolateColor,
  useAnimatedStyle,
} from 'react-native-reanimated'
import useChecklistStateAnimation from './useChecklistItemStateAnimation'
import { ChecklistItemState, getChecklistItemStateNumberArray } from './types'
import {
  animationConfig,
  getColorsArray,
  getNumbersArray,
  pointBorderColor,
  pointBorderWidth,
  pointColorBack,
  pointColorFront,
} from './styles'
import { Pressable } from 'react-native'

interface Props {
  index: number
  state: ChecklistItemState
  hideNumber?: boolean
  onPress: () => void
}

export default function CheckListNumber({
  index,
  state,
  hideNumber,
  onPress,
}: Props) {
  const animation = useChecklistStateAnimation(state, animationConfig)
  const animationSteps = getChecklistItemStateNumberArray

  const backgroundColors = getColorsArray(pointColorBack)
  const borderColors = getColorsArray(pointBorderColor)
  const borderWidths = getNumbersArray(pointBorderWidth)
  const textColors = getColorsArray(pointColorFront)

  const style = useAnimatedStyle(() => {
    return {
      backgroundColor: interpolateColor(
        animation.value,
        animationSteps,
        backgroundColors
      ),
      borderColor: interpolateColor(
        animation.value,
        animationSteps,
        borderColors
      ),
      borderWidth: interpolate(animation.value, animationSteps, borderWidths),
    }
  })

  const styleCheck = useAnimatedStyle(() => {
    return {
      opacity: animation.value,
      transform: [
        {
          scale: interpolate(
            animation.value,
            animationSteps,
            [0, 0, 1, 1, 1, 0, 0]
          ),
        },
      ],
    }
  })
  const styleNumber = useAnimatedStyle(() => {
    return {
      opacity: interpolate(
        animation.value,
        animationSteps,
        [1, 1, 0, 0, 0, 1, 1]
      ),
      transform: [
        {
          scale: interpolate(
            animation.value,
            animationSteps,
            [1, 1, 0, 0, 0, 1, 1]
          ),
        },
      ],
    }
  })

  const styleText = useAnimatedStyle(() => {
    return {
      color: interpolateColor(animation.value, animationSteps, textColors),
    }
  })

  return (
    <Pressable onPress={onPress}>
      <Animated.View
        style={style}
        className={cn('h-8 w-8 items-center justify-center rounded-full')}
      >
        <Animated.View
          style={styleNumber}
          className="absolute inset-0 items-center justify-center"
        >
          {!hideNumber && (
            <Typography
              variant="H5"
              className="text-[16px] leading-normal"
              style={styleText}
            >
              {index + 1}
            </Typography>
          )}
        </Animated.View>
        <Animated.View
          className="absolute inset-0 items-center justify-center"
          style={styleCheck}
        >
          <Icon name="check" color={colors.white} strokeWidth={4} size={20} />
        </Animated.View>
      </Animated.View>
    </Pressable>
  )
}
